export class FlatProductTransformer {
    transform(filteredProducts, allProducts, allProductGroups) {
        return filteredProducts;
    }
}
export class HierarchicalProductTransformer {
    constructor(depth = 0) {
        this.depth = depth;
        if (depth > 0) {
            throw new Error('HierarchicalProductTransformer: nested ProductGroups are not supported yet');
        }
    }
    static filter(productIds, allProductGroups) {
        const result = [];
        for (const group of allProductGroups) {
            const newGroup = Object.assign(Object.assign({}, group), { children: [] });
            for (const child of group.children) {
                if (productIds.includes(child._id)) {
                    newGroup.children.push(child);
                }
            }
            if (newGroup.children.length > 0) {
                result.push(newGroup);
            }
        }
        return result;
    }
    transform(products, allProducts, allProductGroups) {
        return HierarchicalProductTransformer.filter(products.map(product => product._id), allProductGroups);
    }
}
//# sourceMappingURL=ProductTransformer.js.map